module.exports = __webpack_public_path__ + "static/media/textotecnologia.b1eb4e9a.png";